import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the toast styles
import "./Components.scss";

function ContactForm() {
    const [formData, setFormData] = useState({
        from_name: "",
        from_email: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .send(
                "service_o4uu03l", // Replace with your EmailJS service ID
                "template_cvx5idm", // Replace with your EmailJS template ID
                formData,
                "lZQFukxjNs4QpBw2J" // Replace with your EmailJS public key
            )
            .then(() => {
                toast.success("Mesazhi u dergua me sukses!");
                setFormData({ from_name: "", from_email: "", message: "" }); // Clear form
            })
            .catch((err) => {
                toast.error("Ju lutem provoni perseri!");
            });
    };

    return (
        <form className="w-full flex flex-col" onSubmit={sendEmail}>
            <div className="grid grid-cols-12 gap-5 mt-10">
                <div className="col-span-12 lg:col-span-6">
                    <input 
                        type="text" 
                        name="from_name"
                        value={formData.from_name} 
                        onChange={handleChange}
                        className="w-full contact-inputs small-inputs montserrat text-lg" 
                        placeholder="Emri..." 
                        required 
                    />
                </div>
                <div className="col-span-12 lg:col-span-6">
                    <input 
                        type="email" 
                        name="from_email"
                        value={formData.from_email} 
                        onChange={handleChange}
                        className="w-full contact-inputs small-inputs montserrat text-lg" 
                        placeholder="Email..." 
                        required 
                    />
                </div>
            </div>
            <div className="grid-cols-12 mt-5">
                <textarea 
                    name="message"
                    value={formData.message} 
                    onChange={handleChange}
                    className="w-full message-input contact-inputs montserrat text-lg" 
                    placeholder="Mesazhi..." 
                    required
                />
            </div>
            <button 
                type="submit"
                className="px-[20px] w-fit py-[5px] text-lg bg-[#ad2f1e] tex-regular mt-5 font-light text-white"
            >
                Kontakto
            </button>

            {/* Toast notification container */}
            <ToastContainer />
        </form>
    );
}

export default ContactForm;
